import styles from 'pages/contactUs/contactUs.module.css';

import { Element } from 'react-scroll';
import { useTranslation } from 'react-i18next';
import { AnimatedPart } from 'components/animatedPart/AnimatedPart';
import { SocialIcons } from 'components/socialIcons/SocialIcons';

export const ContactUs = () => {
    const { t } = useTranslation();

    return (
        <section id="section-contact-us">
            <Element name="contactUs">
                <div className={styles.contactUs}>
                    <div className={styles.text}>
                        <AnimatedPart>
                            <ul className={styles.info}>
                                <li className={styles.info__item}>
                                    <p>{t('contactUs.phoneNumber')}</p>
                                    <p>
                                        <a href="tel:+33769715909">
                                            +33769715909
                                        </a>
                                    </p>
                                </li>
                                <li className={styles.info__item}>
                                    <p>{t('contactUs.emailAddress')}</p>
                                    <p>
                                        <a
                                            className={styles.info__itemEmail}
                                            href="mailto:lesfemmes.eventshow@gmail.com"
                                        >
                                            lesfemmes.eventshow@gmail.com
                                        </a>
                                    </p>
                                </li>
                                <li className={styles.info__item}>
                                    <p>{t('contactUs.socialMedia')}</p>

                                    <SocialIcons />
                                </li>
                            </ul>
                        </AnimatedPart>
                    </div>
                </div>
            </Element>
        </section>
    );
};
